import { serverApi } from "./serverApi";
import { TestCaseIncomingHistory } from "../types/testCaseIncomingTypes";

export const testCaseIncomingRunHistoryService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getTestCaseIncomingHistory: build.query<Array<TestCaseIncomingHistory>, number>({
      query: (id) => ({
        url: `/test-case-incoming-run-history/history-by-id/${id}`
      })
    }),
  })
});

export const {
  useGetTestCaseIncomingHistoryQuery,
} = testCaseIncomingRunHistoryService;